export enum SheetsScopes {
    DRIVE = "https://www.googleapis.com/auth/drive",
    DRIVE_FILE = "https://www.googleapis.com/auth/drive.file",
    DRIVE_READONLY = "https://www.googleapis.com/auth/drive.readonly",
    SPREADSHEETS = "https://www.googleapis.com/auth/spreadsheets",
    SPREADSHEETS_READONLY = "https://www.googleapis.com/auth/spreadsheets.readonly"
}